import api from "../api";

class logoutService {
  async create() {
    return api.post("/DashBoard/Logout");
  }
}

export default new logoutService();